import { WAY_UP_DEF_IMG } from '../const/way_up'
export const get_template_booking_event = (data) => {
    return `
    <div class="application-card card">
        <div class="application-card__img">
        ${data.image ? `<img class="image" src="${data.image}" alt="event">` : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
        </div>
        <div class="application-card-content">
            ${data.title ? `<p class="application-card__title">${data.title}</p>` : ``}
            ${data.address ? `<p class="application-card__text">${data.address}</p>` : ``}
            <a class="btn btn_primary req-modal__btn js-back-events" href="#section_booking_events"> Сменить дом </a>
        </div>
    </div>`
}

export const get_template_application_month = (data) => {
    const date = new Date();
    const year = date.getFullYear();
    return `
    ${Object.entries(data).map(month =>
        `<div class="radio__option radio__option_pad">
        <input class="radio__input js-radio-input js-target-month" type="radio" data-year='${month[1].year}' name="month" value='${month[1].month}' data-month='${month[0]}' >
        <label class="radio__label" for="month">${month[0]}${month[1].year !== year ? ' ' + month[1].year + ' г.' : ''}</label>
        </div>`
    )}
    `
}

export const get_template_application_date = (data) => {
    let text = ''
    Object.entries(data).forEach((month) => {
        text += `<div class='hidden-wrap js-trigger-month' data-mount='${month[1].month}'>
        <div class="booking-horizontal-wrap">`
        month[1].dates.forEach(i =>
            text += `<div class="radio__option application-days-block">
                <input class="radio__input js-radio-input" type="radio" name="day" data-week='${i.day_week}' value='${i.day}' ${i.free ? '' : 'disabled '}>
                <label class="radio__label" for="day"><span class="day">${i.day}</span>
                    <span class="weekday">${i.day_week}</span>
                </label>
            </div>`
        )
    })
    return text += `</div></div>`
}

export const get_template_application_times = (data) => {
    return `
    <div class="radio__option">
        <input class="radio__input js-radio-input" value='${data.time}' type="radio" name="time" ${data.free ? '' : 'disabled'}>
        <label class="radio__label" for="time">${data.time}</label>
    </div>`
}
export const get_template_events = (data) => {
    const lending_type = 3;
    return `
    <div class="application-card card">
        <div class="application-card__img">
        ${data.image ? `<img class="image" src="${data.image}" alt="event">` : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
        </div>
        <div class="application-card-content">
            ${data.title ? `<p class="application-card__title">${data.title}</p>` : ``}
            ${data.address ? `<p class="application-card__text">${data.address}</p>` : ``}
            ${Number(data.event_type) === lending_type ? `
            <a class="btn btn_primary req-modal__btn" href="${data.landing_absolute_url}"> Записаться</a>` :
            `<span class="btn btn_primary req-modal__btn js-target-events" data-type-event='${data.event_type}' data-id='${data.pk}'> Записаться</span>`}
        </div>
    </div>`
}
export const form_registration_template = (data) => {
    let html = '';
    html += data.first_name ? `<div class="input text application-form__input js-input-wrap" data-input="first_name">
            <label class="input__label" for="first_name"><span>ФИО</span></label>
            <input class="input__field js-name" type="text"  name='first_name' placeholder="Иванов Иван Иванович"/>
            <span class="input__error js-input-error" data-error='first_name'></span>
        </div>`: '';
    html += data.phone ? `<div class="input text application-form__input js-group-phone js-input-wrap" data-input="phone">
            <label class="input__label" for="phone"><span>Телефон</span></label>
            <input class="input__field  js-phone" type="tel" name='phone' placeholder="+7 (999) 999-9999" />
            <span class="input__error js-input-error" data-error='phone'></span>
        </div>`: ''
    html += data.flat_number ? ` <div class="input text application-form__input js-input-wrap" data-input="flat_number">
            <label class="input__label" for="flat"><span>№ квартиры</span></label>
            <input class="input__field" type="text" name="flat_number" placeholder="№ квартиры">
            <span class="input__error js-input-error" data-error='flat_number'></span>
        </div>`: '';
    html += data.contract_number ? `<div class="input text application-form__input js-input-wrap" data-input="contract_number">
            <label class="input__label" for="contract"><span>№ договора</span></label>
            <input class="input__field" type="text" name="contract_number" placeholder="№ договора">
            <span class="input__error js-input-error" data-error='contract_number'></span>
        </div>`: '';
    html += data.email ? ` <div class="input text application-form__input js-input-wrap" data-input="email">
            <label class="input__label" for="email"><span>E-mail</span></label>
            <input class="input  input__field js-email" type="text" name='email' placeholder="mail@mail.ru"/>
            <span class="input__error js-input-error" data-error="email"></span>
        </div>`: '';
    data.extra_fields.forEach(i => html += get_template_input_text(i));
    html += data.shareholder ? `<div class="radio input__radio_wrap">
            <label class="radio-button">
                <input type="radio" name="shareholder" value='interested_in_buying' checked required>
                <span class="radio-tick"></span>
                <span class="radio-label">Интересуюсь покупкой</span>
            </label>
            <label class="radio-button">
                <input type="radio" name="shareholder" value="shareholder" required>
                <span class="radio-tick"></span>
                <span class="radio-label">Я дольщик</span>
            </label>
        </div>`: '';
    if (data.add_file_button === true)
      html += data.file_to_download ? `<div class="file_download_link"></div>` : '';
    return html
}
export const get_template_file_button = (data) => {
    let html = '';
    if (data.add_file_button === true)
        html += data.file_to_download ? `<a href="${data.file_to_download}" target="_blank" class="btn btn_secondary application-form__booking-btn ">
                    <i class="icon icon_list">
                        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.70833 9.16665C3.70833 5.7099 3.70833 3.98106 4.84958 2.90765C5.99083 1.83423 7.82692 1.83331 11.5 1.83331H12.2086C15.1969 1.83331 16.6929 1.83331 17.7306 2.56481C18.0276 2.77381 18.2916 3.02315 18.5143 3.30273C19.2917 4.2799 19.2917 5.68606 19.2917 8.50023V10.8331C19.2917 13.5492 19.2917 14.9077 18.8617 15.9921C18.1706 17.7366 16.7094 19.1116 14.8559 19.7624C13.7037 20.1666 12.2617 20.1666 9.37425 20.1666C7.72608 20.1666 6.90108 20.1666 6.24292 19.9356C5.18417 19.5635 4.34908 18.7779 3.954 17.7815C3.70833 17.1618 3.70833 16.3854 3.70833 14.8335V9.16665Z" stroke="#59B039" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.2917 11C19.2917 11.8103 18.9698 12.5874 18.3968 13.1603C17.8238 13.7333 17.0467 14.0552 16.2364 14.0552C15.6259 14.0552 14.9063 13.9489 14.3133 14.1075C14.0542 14.1771 13.818 14.3136 13.6283 14.5033C13.4387 14.693 13.3022 14.9292 13.2325 15.1882C13.0739 15.7813 13.1803 16.5009 13.1803 17.1114C13.1803 17.5126 13.1012 17.9099 12.9477 18.2806C12.7941 18.6512 12.5691 18.9881 12.2854 19.2718C12.0017 19.5555 11.6649 19.7805 11.2942 19.9341C10.9235 20.0876 10.5262 20.1666 10.125 20.1666M7.83333 6.41663H14.25M7.83333 10.0833H10.5833" stroke="#59B039" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </i>
                    ${data.file_button_title}
                </a>` : '';

    return html
}

export const get_template_input_text = (data) => {
    return `<div class="input text application-form__input js-input-wrap" data-input="${data.name}">
        <label class="input__label" for="${data.name}"><span>${data.label}</span></label>
        <input class="input__field js-input-validate" type="${data.type}" name='extra_fields.${data.name}' placeholder="${data.placeholder}" required/>
        <span class="input__error js-input-error" data-error='${data.name}'></span>
    </div>`
}
